import React from "react"
import { Field, Form } from "react-final-form"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { LoginWithKeycodeErrorHelperText } from "./ErrorHelperText"
import { LoginWithKeycodeFormFieldNames } from "./types"
import { useLoginWithKeycode } from "./useLoginWithKeycode"
import { useCustomerInfo } from "../../../CustomerInfo"
import { PasswordField } from "../../components/PasswordField"
import { StyledLoginForm } from "../../components/StyledLoginForm"
import { SubmitButton } from "../../components/SubmitButton"
import { TextFieldLogon } from "../../components/TextFieldLogon"

const KEYCODE_INPUT_ID = "keycode-input-id"

export const LoginWithKeycodeForm = () => {
  const { i18n } = useTranslations()
  const { handleLogin, error, submitting, cleanError } = useLoginWithKeycode()
  const customerInfo = useCustomerInfo()

  return <Form onSubmit={handleLogin}
               render={({ handleSubmit, values }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                     {customerInfo.data?.keycode?.requireUsername &&
                         <Field name={LoginWithKeycodeFormFieldNames.username}>
                           {({ input }) => <TextFieldLogon
                             {...input} type="text" width="auto" autoComplete="off"
                             placeholder={i18n("Login:Username")}
                             label={i18n("Login:Username")}
                             error={!!error}
                             id={LOGIN_INPUT_ID}
                             inputProps={{
                               "aria-labelledby": LOGIN_INPUT_ID
                             }}
                             disabled={submitting} onChange={(event) => {
                             !!error && cleanError()
                             input.onChange(event)
                           }}/>}
                         </Field>}

                     <PasswordField name={LoginWithKeycodeFormFieldNames.keycode} textFieldProps={{
                       error: !!error,
                       helperText: !!error && <LoginWithKeycodeErrorHelperText error={error.error}/>,
                       disabled: submitting,
                       placeholder: i18n("Account.Login:KeycodePlaceholder"),
                       executeOnChange: cleanError,
                       id: KEYCODE_INPUT_ID
                     }}/>
                   <SubmitButton label={`${i18n("Account.Login:LoginWith")} ${i18n("Account.Login:Keycode")}`} type="submit"
                                 isLoading={submitting}
                                 disabled={submitting}/>
               </StyledLoginForm>}/>
}

const LOGIN_INPUT_ID = "login-input-id"
